import i18n from 'modules/core/lib/i18n'

import { WithCustomizationFieldsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

import LocationInput from './LocationInput'

interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {
  index: number
  onPlaceSelected?: (place: { lat: number; lng: number }) => void
  onInputChange?: () => void
}

const StopField = ({ index, ...props }: Props) => {
  return (
    <LocationInput
      {...props}
      fieldName={`stops.${index}.name`}
      label={i18n.t('expenses_v2.forms.fields.stop.label', { number: index + 1 })}
      placeholder={i18n.t('expenses_v2.forms.fields.stop.placeholder')}
    />
  )
}

export default withFieldPermissions(StopField, 'stops')
